import React from 'react';
import WebSocketContext from './WebSocketContext';

const withWebSocket = (WrappedComponent) => {
  return function WithWebSocket(props) {
    return (
      <WebSocketContext.Consumer>
        {({ sendMessage, reconnect, needsRefresh, setNeedsRefresh, ...webSocket }) => (
          <WrappedComponent
            {...props}
            webSocket={webSocket}
            sendMessage={sendMessage}
            reconnect={reconnect}
            needsRefresh={needsRefresh}
            setNeedsRefresh={setNeedsRefresh}
          />
        )}
      </WebSocketContext.Consumer>
    );
  };
};

export default withWebSocket;
